/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { riskPoliciesList } from "../funcs/riskPoliciesList.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListRiskPoliciesResult } from "../models/components/listriskpoliciesresult.js";
import {
  ListRiskPoliciesRequest,
  ListRiskPoliciesSecurity,
} from "../models/operations/listriskpolicies.js";
import { unwrapAsync } from "../types/fp.js";
export type RiskListPoliciesQueryData = ListRiskPoliciesResult;

export function prefetchRiskListPolicies(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListRiskPoliciesRequest | undefined,
  security?: ListRiskPoliciesSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildRiskListPoliciesQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildRiskListPoliciesQuery(
  client$: GramCore,
  request?: ListRiskPoliciesRequest | undefined,
  security?: ListRiskPoliciesSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<RiskListPoliciesQueryData>;
} {
  return {
    queryKey: queryKeyRiskListPolicies({
      gramKey: request?.gramKey,
      gramSession: request?.gramSession,
      gramProject: request?.gramProject,
    }),
    queryFn: async function riskListPoliciesQueryFn(
      ctx,
    ): Promise<RiskListPoliciesQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(riskPoliciesList(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyRiskListPolicies(
  parameters: {
    gramKey?: string | undefined;
    gramSession?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "policies", "list", parameters];
}
